// Generated by scripts/generate-icons.ts
/* eslint-disable */

// This file is auto-generated. Do not edit manually.
import React from 'react';
import { BaseIcon } from '../src/components/BaseIcon';
import type { IconDefinition, IconPath } from '../src/types/IconData.types';

const iconData: IconDefinition = {
  name: "Tick",
  viewBox: "0 0 33 32",
  paths: [
    {
      d: "M25.82 9.748c.23.204.24.546.023.762L14.078 22.231a.6.6 0 0 1-.409.169.6.6 0 0 1-.413-.158l-6.289-5.925a.52.52 0 0 1 0-.763.6.6 0 0 1 .81 0l5.873 5.533L25.01 9.769a.6.6 0 0 1 .81-.021"
    }
  ]
};

export const TickIcon: React.FC<React.SVGProps<SVGSVGElement> & { iconPathClassName?: string }> = (props) => {
  return <BaseIcon icon={iconData} {...props} />;
};
